// extracted by mini-css-extract-plugin
module.exports = {"root":"Subtitle-root-a7eea672e8c632bce9e832123066a1cd"};